@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: flex;

  .fluid-link {
    flex: 0 1 auto;
    display: inline-flex;
    align-items: center;
    font-weight: $font-weight-bold;
    color: var(--G-color-link);
    text-decoration: none;
    cursor: pointer;

    @include transition(
      $properties: 'color',
      $duration: short
    );

    // ==== Hover / Focus States

    &:not(.disabled) {
      &:hover {
        text-decoration: underline;
      }
    }

    &:hover,
    &:focus-visible {
      color: var(--G-color-link-hover);
    }

    // ==== Light Variation

    &.color-scheme-light {
      color: var(--color-light);

      &:hover,
      &:focus-visible {
        color: var(--color-light-hover);
      }
    }

    // ==== Dark Variation

    &.color-scheme-dark {
      color: var(--color-dark);

      &:hover,
      &:focus-visible {
        color: var(--color-dark-hover);
      }
    }

    // ==== Inline

    &.inline {
      font-weight: $font-weight-regular;
      text-decoration: underline;

      &:not(.disabled) {
        &:hover {
          text-decoration: none;
        }
      }
    }

    // ==== Disabled State

    &.disabled {
      color: var(--G-color-link-disabled);
      cursor: not-allowed;

      // == Override :hover & :focus-visible states above

      &:hover,
      &:focus-visible {
        color: var(--G-color-link-disabled);
      }
    }

    // ==== Centered

    &.center {
      text-align: center;
    }

    // ==== Anchor Text / Content

    .link-content {
      display: block;
      font-family: inherit;
      font-size: inherit;
      font-weight: inherit;
      color: inherit;
      text-decoration: inherit;
    }

    // ==== Icons (Embedded / Slotted)

    .link-icon,
    [slot] fluid-icon,
    ::slotted(fluid-icon) {
      color: inherit; // Sets FLUID Icon "fill" color
    }

    .icon-before {
      margin-right: 0.4em;
    }

    .icon-after {
      margin-left: 0.4em;
    }
  }
}

// ==== Inline Link

:host(.fluid-link--inline) {
  display: inline-flex;
}

// ==== Centered Link

:host(.fluid-link--center) {
  justify-content: center;
}
